import React from 'react';
import { motion } from 'framer-motion';
import styles from './HomeLocationSection.module.css';

const HomeLocationSection = () => {
  // Animation Variants
  const textContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.1 }
    }
  };

  const itemFade = {
    hidden: { opacity: 0, x: -20 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Top Text Content */}
        <motion.div
          className={styles.textContent}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={textContainer}
        >
          <motion.span variants={itemFade} className={styles.subheading}>
            Visit us
          </motion.span>
          <motion.h2 variants={itemFade} className={styles.heading}>
            At Baglami, Thoughtfully Curated Dining, Refined Spaces, and Exceptional Experiences Come Together
          </motion.h2>
          <motion.a
            variants={itemFade}
            href="#location"
            className={styles.link}
            whileHover={{ x: 5 }}
          >
            Location Details <span className={styles.arrow}>↘</span>
          </motion.a>
        </motion.div>

        {/* Image Grid */}
        <div className={styles.imageGrid}>
          <motion.div
            className={styles.largeImageWrapper}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <img
              src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/Outside%20Image.jpeg"}
              alt="Restaurant Exterior"
              className={styles.image}
            />
          </motion.div>

          <motion.div
            className={styles.smallImageWrapper}
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
          >
            <img
              src={"https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/The%20kind%20of%20dish%20that%20tastes%20like%20memory%2C%20but%20looks%20like%20art.Hearty%2C%20familiar%20layers%20reimagined%20.jpg"}
              alt="Pasta Dish"
              className={styles.image}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HomeLocationSection;